/* eslint-disable max-len */

import React from 'react'
import { Link } from 'react-router-dom'

function ViewAlloffer({setshowRelated,relatedOffers}) {
    return (
        <div className="modal-dialog modal-dialog-centered relative xl:max-w-[1028px] md:max-w-[900px] max-w-[850px] lg:mx-auto mx-2 pointer-events-none">
            <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                <div className="relative">
                    <h5 className="text-xs4 font-bold text-[#44445E] flex justify-center pt-5" id="exampleModalScrollableLabel">
                        Related Offers
                    </h5>
                    <div className="modal-header flex flex-shrink-0 items-center pt-5 rounded-t-md">
                        <button onClick={()=>setshowRelated(false)} type="button "
                            className="btn-close1 absolute top-5 right-4 box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                            data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                </div>
                <div style={{maxHeight:'500px',overflow:'auto'}}>{relatedOffers.map((offer,i)=>(
                    <div className="pb-5" key={i} >
                        <div className="lg:px-[56px] px-5">
                            <div className="w-full rounded-[10px] shadow-s7 p-2.5 mb-2">
                                <div className="relative ">
                                    <ul className="flex justify-end items-center sm:flex-col flex-row">
                                        <li>
                                            <button type="button" className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit absolute right-12 top-2">{offer?.offer_type}</button>
                                        </li>
                                        <li>
                                            <button type="button" className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit absolute right-2 top-2">{offer?.industrial_pocket}</button>
                                        </li>
                                    </ul>
                                    <div className="">
                                        <div className="flex items-center justify-between mt-5 lg:flex-nowrap flex-wrap">
                                            <div className="flex items-center sm:flex-nowrap flex-wrap">
                                                <img src="/images/related-offer.svg" alt="icon" />
                                                <div className="pl-5 w-full">
                                                    <ul className="sm:mt-0 mt-2">
                                                        <li className="font-semibold text-base text-[#090406]">{offer?.offer_code}</li>
                                                        <li className="text-[#44445E] font-normal text-xs13 my-[7px]">Validity: <span className="font-semibold text-[#44445E] text-xs13">{offer?.start_date.split("-").reverse().join("-")?.replace(/-/g,'/')} - {offer?.end_date?.split("-").reverse().join("-").replace(/-/g,'/')}</span><span className="px-2">|</span><span className="font-semibold text-[#44445E] text-xs13">{offer?.offer_value}</span></li>
                                                        <li className="text-[#44445E] font-normal text-xs2">{offer?.description}</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="flex items-center justify-end lg:mt-10 mt-5 sm:ml-0 ml-5">
                                                <Link to={`/offers/${offer?.offer_code.split('/').join('-')}?code=${encodeURIComponent(offer?.offer_code)}`}>
                                                    <button type="button" className="sm:w-[284px] w-[170px] h-10 rounded-lg bg-[#555259] font-semibold text-sm text-[#FFFFFF]">
                                                        View Offer
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                ))}</div>
            </div>
        </div>
    )
}

export default ViewAlloffer